<div class="modal-backdrop" role="presentation" (click)="cancelled.emit()">
  <section class="confirm-dialog" role="dialog" aria-modal="true" [attr.aria-label]="title" (click)="$event.stopPropagation()">
    <div class="dialog-icon" [class.danger]="tone === 'danger'">
      <i class="material-icons">{{ tone === 'danger' ? 'warning' : 'help' }}</i>
    </div>
    <div>
      <h3>{{ title }}</h3>
      <p>{{ message }}</p>
    </div>
    <div class="dialog-actions">
      <button class="secondary-action" type="button" autofocus (click)="cancelled.emit()">{{ cancelLabel }}</button>
      <button class="primary-action" type="button" [class.danger]="tone === 'danger'" (click)="confirmed.emit()">{{ confirmLabel }}</button>
    </div>
  </section>
</div>
